import React 			from 'react'
import renderHTML 		from 'react-render-html'

import {
	TextBlockQuote
} from '../../../text-block'

import Section 			from '../section'

export default (props) => {
	const {
		quote,
		quote_display,
		name,
		role
	} = props

	const displayRule = quote_display === 'inline'

	return <Section
		type="quote"
		indent={ true }
		>
		{ quote ? <TextBlockQuote
			quote={ quote }
			person={ name }
			position={ role }
			display={ displayRule ? 'rule' : null }
			small={ !displayRule }
			/> : null }
	</Section>
}